import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "heading" }
const _hoisted_3 = { class: "heading-row" }
const _hoisted_4 = { class: "title-content" }
const _hoisted_5 = ["actions"]
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "number-cards" }
const _hoisted_8 = {
  class: "dashboard-card",
  variant: "info"
}
const _hoisted_9 = { slot: "title" }
const _hoisted_10 = { class: "number-text" }
const _hoisted_11 = { class: "number" }
const _hoisted_12 = {
  class: "dashboard-card",
  variant: "info"
}
const _hoisted_13 = { slot: "title" }
const _hoisted_14 = { class: "number-text" }
const _hoisted_15 = { class: "number" }
const _hoisted_16 = {
  class: "dashboard-card",
  variant: "info"
}
const _hoisted_17 = { slot: "title" }
const _hoisted_18 = { class: "number-text" }
const _hoisted_19 = { class: "number" }
const _hoisted_20 = {
  key: 0,
  class: "mt-20"
}
const _hoisted_21 = {
  key: 1,
  class: "deployment"
}
const _hoisted_22 = { class: "simple-box-row app-instances" }
const _hoisted_23 = {
  variant: "info",
  class: "dashboard-card simple-box"
}
const _hoisted_24 = {
  slot: "title",
  class: "consumption-card"
}
const _hoisted_25 = { class: "instances" }
const _hoisted_26 = ["value", "total"]
const _hoisted_27 = { class: "instances-controls" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 1,
  class: "scale-instances__spinner mt-5"
}
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { class: "deployment__origin__row" }
const _hoisted_32 = { class: "stats-table" }
const _hoisted_33 = { class: "mt-15" }
const _hoisted_34 = {
  key: 0,
  variant: "info",
  class: "dashboard-card simple-box"
}
const _hoisted_35 = {
  slot: "title",
  class: "deployment__origin__list"
}
const _hoisted_36 = { class: "origin-prop" }
const _hoisted_37 = { class: "origin-value" }
const _hoisted_38 = { class: "origin-prop" }
const _hoisted_39 = {
  key: 0,
  class: "origin-value"
}
const _hoisted_40 = ["href"]
const _hoisted_41 = {
  key: 1,
  class: "origin-value"
}
const _hoisted_42 = ["href"]
const _hoisted_43 = {
  key: 2,
  class: "origin-value"
}
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { class: "origin-prop" }
const _hoisted_46 = { class: "origin-value" }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "origin-prop" }
const _hoisted_49 = { class: "origin-value" }
const _hoisted_50 = { class: "origin-prop" }
const _hoisted_51 = { class: "origin-value" }
const _hoisted_52 = ["rows", "columns"]
const _hoisted_53 = { class: "mt-20" }
const _hoisted_54 = ["rows"]
const _hoisted_55 = ["rows"]
const _hoisted_56 = ["rows"]

import { ref, computed, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import day from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import Application from '../models/applications';
import { GitUtils } from '@shell/utils/git';
import { isArray } from '@shell/utils/array';
import { EPINIO_TYPES } from '../types';
import { epinioExceptionToErrorsArray } from '../utils/errors';
import Tabs from '../components/application/Tabs.vue';
import Banner from '@components/Banner/Banner.vue';
import { makeStateTag, makeActionMenu, makeCommitShaCell, makeCommitAuthorCell, overrideTableRows } from '../utils/table-formatters';
import ServiceInstanceModal from '../components/service/ServiceInstanceModal.vue';
import ServiceDeleteModal from '../components/service/ServiceDeleteModal.vue';
import EpinioServiceModel from 'models/services';
import ConfigurationModal from '../components/configuration/ConfigurationModal.vue';
import ConfigurationDeleteModal from '../components/configuration/ConfigurationDeleteModal.vue';
import AppModal from '../components/application/AppModal.vue';
import ExportAppModal from '../dialog/ExportAppModal.vue';
import AppDeleteModal from '../components/application/AppDeleteModal.vue';

const UPDATE_INSTANCES_DEBOUNCE_MS = 2000; // 2s; adjust as needed

export default /*@__PURE__*/_defineComponent({
  __name: 'applications',
  props: {
    value: {},
    initialValue: {},
    mode: {}
  },
  setup(__props: any) {

day.extend(relativeTime);

const props = __props;

const store = useStore();

const t = store.getters['i18n/t'];

const scalingInFlight = ref(false);
const debouncePending = ref(false);
const gitSource = ref<any>(null);
const gitDeployment = ref({
  deployedCommit: { short: '', long: '' },
  commits: null as any
});
const activeDeploymentTab = ref<string | number>('overview');
const deploymentTabs = ref([
  { id: 'overview', label: t('epinio.applications.detail.tables.overview'), completed: false, valid: true, disabled: false },
])
const activeResourceTab = ref<string | number>('instances');
const resourceTabs = ref([
  { id: 'instances', label: t('epinio.applications.detail.tables.instances'), completed: false, valid: true, disabled: false },
  { id: 'services', label: t('epinio.applications.detail.tables.services'), completed: false, valid: true, disabled: false },
  { id: 'configs', label: t('epinio.applications.detail.tables.configs'), completed: false, valid: true, disabled: false }
]);

const serviceModal = ref<InstanceType<typeof ServiceInstanceModal> | null>(null);
const serviceDeleteModal = ref<InstanceType<typeof ServiceDeleteModal> | null>(null);
const serviceRows = ref<any[]>([]);

const configModal = ref<InstanceType<typeof ConfigurationModal> | null>(null);
const configDeleteModal = ref<InstanceType<typeof ConfigurationDeleteModal> | null>(null);
const configRows = ref<any[]>([]);

const appModal = ref<InstanceType<typeof AppModal> | null>(null);
const exportAppModal = ref<InstanceType<typeof ExportAppModal> | null>(null);
const appDeleteModal = ref<InstanceType<typeof AppDeleteModal> | null>(null);

const availableActions = computed(() => {
  const actions = props.value.availableActions.filter((action) => action.action !== 'showConfiguration') || [];

  return actions.map((action) => {
    if (action.action === 'goToEdit') {
      return {
        ...action,
        label: 'Edit',
        action: () => appModal.value?.openEdit(props.value),
        disabled: !canEdit.value,
        visible: canEdit.value
      };
    }

    if (action.action === 'exportApp') {
      return {
        ...action,
        action: () => exportAppModal.value?.openExport([props.value])
      };
    }

    if (action.action === 'promptRemove') {
      return {
        ...action,
        action: () => appDeleteModal.value?.openDelete(props.value),
        disabled: !canEdit.value,
        visible: canEdit.value
      };
    }

    return {
      ...action,
      action: () => props.value[action.action]?.(),
    };
  });
});

const instanceColumns = [
  {
    field: 'stateDisplay',
    label: 'State',
    width: '100px',
    formatter: (_v: any, row: any) => makeStateTag(row)
  },
  {
    field: 'name',
    label: 'Name',
    formatter: (_v: any, row: any) => {
      const nameText = document.createElement('p');
      nameText.textContent = row.nameDisplay || row.meta?.name || '';
      nameText.style.whiteSpace = 'normal';
      nameText.style.wordBreak = 'break-word';
      return nameText;
    }
  },
  {
    field: 'millicpus',
    label: 'Mill CPUs',
    formatter: 'milliCPUs'
  },
  {
    field: 'memoryBytes',
    label: 'RAM',
    formatter: 'memory'
  },
  {
    field: 'restarts',
    label: 'Restarts'
  },
  {
    field: 'createdAt',
    label: 'Age',
    formatter: 'age'
  }
];

const serviceColumns = [
  {
    field: 'stateDisplay',
    label: 'State',
    width: '100px',
    formatter: (_v: any, row: any) => makeStateTag(row)
  },
  {
    field: 'nameDisplay',
    label: 'Name'
  },
  {
    field: 'catalog_service',
    label: 'Catalog Service'
  },
  {
    field: 'catalog_service_version',
    label: 'Catalog Service Version'
  },
  {
    field: 'meta.createdAt',
    label: 'Age',
    formatter: 'age'
  }
];

const configColumns = [
  {
    field: 'nameDisplay',
    label: 'Name'
  },
  {
    field: 'variableCount',
    label: 'No. of Variables'
  },
  {
    field: 'configuration.user',
    label: 'Created By'
  },
  {
    field: 'meta.createdAt',
    label: 'Age',
    formatter: 'age'
  }
];

const canEdit = computed(() => {
  const canGetter = store.getters['epinio/can'];
  return canGetter && (
    canGetter('app_update') || canGetter('app_write') || canGetter('app')
  );
});
const canScale = computed(() => {
  const canGetter = store.getters['epinio/can'];
  return canGetter && (
    canGetter('app_scale') || canGetter('app_write') || canGetter('app')
  );
});

// Bound resources on this page have their own scope: the services table
// requires service write perms, the configurations table requires config
// write perms — independent of app perms.
const canEditService = computed(() => {
  const canGetter = store.getters['epinio/can'];
  return canGetter && (canGetter('service_write') || canGetter('service'));
});
const canEditConfig = computed(() => {
  const canGetter = store.getters['epinio/can'];
  return canGetter && (canGetter('configuration_write') || canGetter('configuration'));
});


watchEffect(() => {
  const all = [...props.value.services];

  all.forEach((row: any) => { void row.status; void row.stateDisplay; void row.meta; });

  // Filter empty rows that are added during delete
  const filtered = all.filter((row) => {
    if (!row.id) return false;
    else return true;
  });

  // Bound-services row actions are gated by service write perms.
  const overrideProps = [
    {
      prop: 'availableActions',
      value: (row: EpinioServiceModel) => {
        const out: any[] = [];

        if (canEditService.value) {
          out.push(
            {
              action: 'removeService',
              altAction: 'remove',
              bulkAction: 'removeService',
              bulkable: true,
              enabled: row.canDelete,
              icon: 'icon icon-trash',
              label: 'Delete',
              weight: -10
            },
            {
              action: 'editServiceModal',
              label: 'Edit',
              enabled: true
            }
          );
        }

        return out;
      },
      conditionFn: () => true,
    },
    {
      prop: 'removeService',
      value: (row: EpinioServiceModel) => () => {
        serviceDeleteModal.value?.openDelete(row);
      },
      conditionFn: (row: EpinioServiceModel) => canEditService.value && row.canDelete,
    },
    {
      prop: 'editServiceModal',
      value: (row: EpinioServiceModel) => () => {
        serviceModal.value?.openEdit(row);
      },
      conditionFn: () => canEditService.value,
    }
  ];

  serviceRows.value = [...overrideTableRows(filtered, overrideProps)];
});

watchEffect(() => {
  const all = [...props.value.baseConfigurations];

  all.forEach((row: any) => { void row.status; void row.stateDisplay; void row.meta; });

  const overrides = [
    {
      prop: 'availableActions',
      value: (row: any) => {
        if (!canEditConfig.value) return [];

        return [
          {
            action:  'editConfigModal',
            label:   'Edit',
            enabled: row.configuration?.type === 'custom',
            icon:    'icon icon-edit',
          },
          {
            action:  'deleteConfigModal',
            label:   'Delete',
            enabled: row.configuration?.type === 'custom',
            icon:    'icon icon-trash',
            weight:  -10,
          },
        ];
      },
      conditionFn: () => true,
    },
    {
      prop:        'editConfigModal',
      value:       (row: any) => () => { configModal.value?.openEdit(row); },
      conditionFn: (row: any) => canEditConfig.value && row.configuration?.type === 'custom',
    },
    {
      prop:        'deleteConfigModal',
      value:       (row: any) => () => { configDeleteModal.value?.openDelete(row); },
      conditionFn: (row: any) => canEditConfig.value && row.configuration?.type === 'custom',
    },
  ];

  configRows.value = [...overrideTableRows(all, overrides)];
});

const commitActions = computed(() => canEdit.value ? [{
  action: 'editFromCommit',
  label: t('epinio.applications.actions.editFromCommit.label'),
  icon: 'icon icon-edit',
  enabled: true
}] : []);

// Debounce settings for scaling instances
let updateInstancesTimeout: number | null = null;

onMounted(async () => {
  await store.dispatch('epinio/me'); //Need to fetch fresh rights for scaling
  await store.dispatch('epinio/findAll', { type: EPINIO_TYPES.SERVICE_INSTANCE });
  await store.dispatch('epinio/findAll', { type: EPINIO_TYPES.CONFIGURATION });

  if (props.value.appSource.git) {
    await fetchRepoDetails();
    setCommitDetails();
    deploymentTabs.value.push(
      { id: 'gitCommits', label: t('epinio.applications.detail.tables.gitCommits'), completed: false, valid: true, disabled: false }
    );
  }
});

async function updateInstances(newInstances: number) {
  // Update desired and configured instances immediately so the UI reflects the target
  props.value.desiredInstances = newInstances;
  props.value.configuration.instances = newInstances;

  // Debounce the API call so rapid clicks collapse into one request
  if (updateInstancesTimeout !== null) {
    clearTimeout(updateInstancesTimeout);
  }
  debouncePending.value = true;

  updateInstancesTimeout = window.setTimeout(async () => {
    debouncePending.value = false;
    scalingInFlight.value = true;

    try {
      await props.value.update();
      await props.value.forceFetch();
    } catch (err) {
      console.error('[Epinio instances] Failed to scale Application', epinioExceptionToErrorsArray(err));
    } finally {
      scalingInFlight.value = false;
      debouncePending.value = false;
      updateInstancesTimeout = null;
    }
  }, UPDATE_INSTANCES_DEBOUNCE_MS);
}

const showScaleSpinner = computed(() => debouncePending.value || scalingInFlight.value);

function formatURL(str: string) {
  const matchGit = str.match('^(https|git)(:\/\/|@)([^\/:]+)[\/:]([^\/:]+)\/(.+)(.git)*$'); // eslint-disable-line no-useless-escape
  return `${matchGit?.[4]}/${matchGit?.[5]}`;
}

async function fetchRepoDetails() {
  const { usernameOrOrg, repo } = props.value.appSource.git;
  const res = await store.dispatch(`${gitType.value}/fetchRepoDetails`, { username: usernameOrOrg, repo });

  gitSource.value = GitUtils[gitType.value].normalize.repo(res);
  await fetchCommits();
}

async function fetchCommits() {
  const { usernameOrOrg, repo, branch } = props.value.appSource.git;

  if (branch?.name) {
    gitDeployment.value.commits = await store.dispatch(`${gitType.value}/fetchCommits`, {
      username: usernameOrOrg, repo, branch
    });
  }
}

function setCommitDetails() {
  const { commit } = props.value.appSource.git;
  const selectedCommit = preparedCommits.value.find((c) => c.commitId === commit);

  gitDeployment.value.deployedCommit = {
    short: selectedCommit?.commitId?.slice(0, 7),
    long: selectedCommit.commitId
  };
}

const gitType = computed(() => props.value.appSource?.type || null);

const preparedCommits = computed(() => {
  const commits = gitDeployment.value.commits;

  if (!commits) {
    return [];
  }

  const arr = isArray(commits) ? commits : [commits];

  return arr.map((c: { sha: any; id: any; }) => ({
    ...GitUtils[gitType.value].normalize.commit(c),
    availableActions: commitActions.value,
    editFromCommit: () => appModal.value?.openEdit(props.value, c.sha)
  }));
});

const gitCommitsColumns = computed(() => [
  {
    field: 'sha',
    label: t(`gitPicker.${gitType.value}.tableHeaders.sha.label`),
    width: '100px',
    formatter: (_v: any, row: any) => makeCommitShaCell(
      row,
      gitDeployment.value.deployedCommit.long,
      t('epinio.applications.detail.deployment.details.git.deployed')
    )
  },
  {
    field: 'author_login',
    label: t(`gitPicker.${gitType.value}.tableHeaders.author.label`),
    width: '190px',
    formatter: (_v: any, row: any) => makeCommitAuthorCell(
      row,
      t(`gitPicker.${gitType.value}.tableHeaders.author.unknown`)
    )
  },
  {
    field: 'message',
    label: t(`gitPicker.${gitType.value}.tableHeaders.message.label`)
  },
  {
    field: 'date',
    label: t(`gitPicker.${gitType.value}.tableHeaders.date.label`),
    width: '220px',
    formatter: 'dateTime'
  }
]);

function formatDate(date, from) {
  return from ? day(date).fromNow() : day(date).format('DD MMM YYYY');
}

function handleDeleted() {
  // navigate back to the applications list after deletion
  store.$router.push({
    name: 'epinio-c-cluster-applications',
    params: store.$router.currentRoute.params,
  });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", null, "Application: " + _toDisplayString(_ctx.value.meta.name), 1),
            _cache[4] || (_cache[4] = _createTextVNode()),
            _createElementVNode("p", null, _toDisplayString(_ctx.value.stateDisplay), 1)
          ]),
          _cache[5] || (_cache[5] = _createTextVNode()),
          (availableActions.value.length > 0)
            ? (_openBlock(), _createElementBlock("trailhand-action-menu", {
                key: 0,
                actions: availableActions.value
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true)
        ]),
        _cache[6] || (_cache[6] = _createTextVNode()),
        _createElementVNode("h3", null, "Namespace: " + _toDisplayString(_ctx.value.meta.namespace), 1),
        _cache[7] || (_cache[7] = _createTextVNode()),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value.configuration.routes, (route) => {
            return (_openBlock(), _createElementBlock("li", {
              key: route.id
            }, [
              (_ctx.value.state === 'running')
                ? (_openBlock(), _createElementBlock("a", {
                    key: route.id + 'a',
                    href: `https://${route}`,
                    target: "_blank",
                    rel: "noopener noreferrer nofollow"
                  }, _toDisplayString(`https://${route}`), 9, _hoisted_6))
                : (_openBlock(), _createElementBlock("span", {
                    key: route.id + 'b'
                  }, _toDisplayString(`https://${route}`), 1))
            ]))
          }), 128))
        ])
      ]),
      _cache[40] || (_cache[40] = _createTextVNode()),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("trailhand-card", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.value.envCount), 1),
              _createTextVNode(" " + _toDisplayString(_unref(t)('epinio.applications.detail.counts.envVars')), 1)
            ])
          ])
        ]),
        _cache[8] || (_cache[8] = _createTextVNode()),
        _createElementVNode("trailhand-card", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("p", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.value.serviceConfigurations.length), 1),
              _createTextVNode(" " + _toDisplayString(_unref(t)('epinio.applications.detail.counts.services')), 1)
            ])
          ])
        ]),
        _cache[9] || (_cache[9] = _createTextVNode()),
        _createElementVNode("trailhand-card", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("p", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.value.baseConfigurations.length), 1),
              _createTextVNode(" " + _toDisplayString(_unref(t)('epinio.applications.detail.counts.config')), 1)
            ])
          ])
        ])
      ]),
      _cache[41] || (_cache[41] = _createTextVNode()),
      (_ctx.value.deployment || _ctx.value.image_url)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_20, _toDisplayString(_unref(t)('epinio.applications.detail.deployment.label')), 1))
        : _createCommentVNode("", true),
      _cache[42] || (_cache[42] = _createTextVNode()),
      (_ctx.value.deployment || _ctx.value.image_url)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createVNode(Tabs, {
              modelValue: activeDeploymentTab.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeDeploymentTab).value = $event)),
              tabs: deploymentTabs.value,
              variant: "underline"
            }, {
              overview: _withCtx(() => [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("trailhand-card", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("trailhand-progress-bar", {
                          label: "Instances",
                          value: _ctx.value.readyInstances,
                          total: _ctx.value.desiredInstances
                        }, null, 8, _hoisted_26),
                        _cache[15] || (_cache[15] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_27, [
                          (canScale.value)
                            ? (_openBlock(), _createElementBlock("trailhand-button", {
                                key: 0,
                                variant: "secondary",
                                size: "small",
                                disabled: scalingInFlight.value || _ctx.value.desiredInstances <= 0,
                                onButtonClick: _cache[0] || (_cache[0] = ($event: any) => (updateInstances(_ctx.value.desiredInstances - 1)))
                              }, _cache[10] || (_cache[10] = [
                                _createElementVNode("trailhand-icon", { name: "minus" }, null, -1)
                              ]), 40, _hoisted_28))
                            : _createCommentVNode("", true),
                          _cache[13] || (_cache[13] = _createTextVNode()),
                          (showScaleSpinner.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[11] || (_cache[11] = [
                                _createElementVNode("i", { class: "icon-spinner animate-spin" }, null, -1)
                              ])))
                            : _createCommentVNode("", true),
                          _cache[14] || (_cache[14] = _createTextVNode()),
                          (canScale.value)
                            ? (_openBlock(), _createElementBlock("trailhand-button", {
                                key: 2,
                                variant: "secondary",
                                size: "small",
                                disabled: scalingInFlight.value,
                                onButtonClick: _cache[1] || (_cache[1] = ($event: any) => (updateInstances(_ctx.value.desiredInstances + 1)))
                              }, _cache[12] || (_cache[12] = [
                                _createElementVNode("trailhand-icon", { name: "plus" }, null, -1)
                              ]), 40, _hoisted_30))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _cache[25] || (_cache[25] = _createTextVNode()),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("table", _hoisted_33, [
                            _cache[23] || (_cache[23] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th"),
                                _createTextVNode(),
                                _createElementVNode("th", null, "Min"),
                                _createTextVNode(),
                                _createElementVNode("th", null, "Max"),
                                _createTextVNode(),
                                _createElementVNode("th", null, "Avg")
                              ])
                            ], -1)),
                            _cache[24] || (_cache[24] = _createTextVNode()),
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", null, _toDisplayString(_unref(t)('tableHeaders.memory')), 1),
                                _cache[16] || (_cache[16] = _createTextVNode()),
                                _createElementVNode("td", null, _toDisplayString(_ctx.value.instanceMemory.min), 1),
                                _cache[17] || (_cache[17] = _createTextVNode()),
                                _createElementVNode("td", null, _toDisplayString(_ctx.value.instanceMemory.max), 1),
                                _cache[18] || (_cache[18] = _createTextVNode()),
                                _createElementVNode("td", null, _toDisplayString(_ctx.value.instanceMemory.avg), 1)
                              ]),
                              _cache[22] || (_cache[22] = _createTextVNode()),
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", null, _toDisplayString(_unref(t)('tableHeaders.cpu')), 1),
                                _cache[19] || (_cache[19] = _createTextVNode()),
                                _createElementVNode("td", null, _toDisplayString(_ctx.value.instanceCpu.min), 1),
                                _cache[20] || (_cache[20] = _createTextVNode()),
                                _createElementVNode("td", null, _toDisplayString(_ctx.value.instanceCpu.max), 1),
                                _cache[21] || (_cache[21] = _createTextVNode()),
                                _createElementVNode("td", null, _toDisplayString(_ctx.value.instanceCpu.avg), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _cache[35] || (_cache[35] = _createTextVNode()),
                  (_ctx.value.appSourceInfo)
                    ? (_openBlock(), _createElementBlock("trailhand-card", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("table", null, [
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", _hoisted_36, _toDisplayString(_unref(t)('epinio.applications.detail.deployment.details.origin')), 1),
                                _cache[26] || (_cache[26] = _createTextVNode()),
                                _createElementVNode("td", _hoisted_37, _toDisplayString(_ctx.value.appSourceInfo.label), 1)
                              ]),
                              _cache[31] || (_cache[31] = _createTextVNode()),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value.appSourceInfo.details, (d) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: d.label
                                }, [
                                  _createElementVNode("td", _hoisted_38, _toDisplayString(d.label), 1),
                                  _cache[27] || (_cache[27] = _createTextVNode()),
                                  (d.value && d.value.startsWith('http'))
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_39, [
                                        _createElementVNode("a", {
                                          href: d.value,
                                          target: "_blank",
                                          class: "origin-link"
                                        }, _toDisplayString(formatURL(d.value)), 9, _hoisted_40)
                                      ]))
                                    : (gitSource.value && d.value && d.value.match(/^[a-f0-9]{40}$/))
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_41, [
                                          _createElementVNode("a", {
                                            href: `${gitSource.value.htmlUrl}/commit/${d.value}`,
                                            target: "_blank",
                                            class: "origin-link"
                                          }, _toDisplayString(d.value), 9, _hoisted_42)
                                        ]))
                                      : (_openBlock(), _createElementBlock("td", _hoisted_43, _toDisplayString(d.value), 1))
                                ]))
                              }), 128)),
                              _cache[32] || (_cache[32] = _createTextVNode()),
                              (gitSource.value)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_44, [
                                    _createElementVNode("td", _hoisted_45, _toDisplayString(_unref(t)('epinio.applications.detail.deployment.details.git.created')), 1),
                                    _cache[28] || (_cache[28] = _createTextVNode()),
                                    _createElementVNode("td", _hoisted_46, _toDisplayString(formatDate(gitSource.value.created_at, false)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _cache[33] || (_cache[33] = _createTextVNode()),
                              (gitSource.value)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_47, [
                                    _createElementVNode("td", _hoisted_48, _toDisplayString(_unref(t)('epinio.applications.detail.deployment.details.git.updated')), 1),
                                    _cache[29] || (_cache[29] = _createTextVNode()),
                                    _createElementVNode("td", _hoisted_49, _toDisplayString(formatDate(gitSource.value.updated_at, true)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _cache[34] || (_cache[34] = _createTextVNode()),
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", _hoisted_50, _toDisplayString(_unref(t)('epinio.applications.tableHeaders.deployedBy')), 1),
                                _cache[30] || (_cache[30] = _createTextVNode()),
                                _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.value.deployment?.username), 1)
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              gitCommits: _withCtx(() => [
                _createVNode(Banner, {
                  color: "info",
                  class: "redeploy-info"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('epinio.applications.detail.deployment.commits.redeploy')), 1)
                  ]),
                  _: 1
                }),
                _cache[36] || (_cache[36] = _createTextVNode()),
                (preparedCommits.value)
                  ? (_openBlock(), _createElementBlock("trailhand-table", {
                      key: 0,
                      ref: (el) => { if (el) el.renderActions = _unref(makeActionMenu); },
                      rows: preparedCommits.value,
                      columns: gitCommitsColumns.value,
                      "key-field": "sha",
                      searchable: true,
                      paginated: true,
                      "rows-per-page": 10
                    }, null, 8, _hoisted_52))
                  : _createCommentVNode("", true)
              ]),
              _: 1,
              __: [37]
            }, 8, ["modelValue", "tabs"])
          ]))
        : _createCommentVNode("", true),
      _cache[43] || (_cache[43] = _createTextVNode()),
      _createElementVNode("h3", _hoisted_53, _toDisplayString(_unref(t)('epinio.applications.detail.tables.label')), 1),
      _cache[44] || (_cache[44] = _createTextVNode()),
      _createElementVNode("div", null, [
        _createVNode(Tabs, {
          modelValue: activeResourceTab.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((activeResourceTab).value = $event)),
          tabs: resourceTabs.value,
          variant: "underline"
        }, {
          instances: _withCtx(() => [
            _createElementVNode("trailhand-table", {
              ref: (el) => { if (el) el.renderActions = _unref(makeActionMenu); },
              columns: instanceColumns,
              rows: _ctx.value.instances,
              searchable: false,
              paginated: false
            }, null, 8, _hoisted_54)
          ]),
          services: _withCtx(() => [
            _createElementVNode("trailhand-table", {
              ref: (el) => { if (el) el.renderActions = _unref(makeActionMenu); },
              columns: serviceColumns,
              rows: serviceRows.value,
              searchable: false,
              paginated: false
            }, null, 8, _hoisted_55)
          ]),
          configs: _withCtx(() => [
            _createElementVNode("trailhand-table", {
              ref: (el) => { if (el) el.renderActions = _unref(makeActionMenu); },
              columns: configColumns,
              rows: configRows.value,
              searchable: false,
              paginated: false
            }, null, 8, _hoisted_56)
          ]),
          _: 1,
          __: [38,39]
        }, 8, ["modelValue", "tabs"])
      ])
    ]),
    _cache[45] || (_cache[45] = _createTextVNode()),
    _createVNode(ServiceInstanceModal, {
      ref_key: "serviceModal",
      ref: serviceModal
    }, null, 512),
    _cache[46] || (_cache[46] = _createTextVNode()),
    _createVNode(ServiceDeleteModal, {
      ref_key: "serviceDeleteModal",
      ref: serviceDeleteModal
    }, null, 512),
    _cache[47] || (_cache[47] = _createTextVNode()),
    _createVNode(ConfigurationModal, {
      ref_key: "configModal",
      ref: configModal
    }, null, 512),
    _cache[48] || (_cache[48] = _createTextVNode()),
    _createVNode(ConfigurationDeleteModal, {
      ref_key: "configDeleteModal",
      ref: configDeleteModal
    }, null, 512),
    _cache[49] || (_cache[49] = _createTextVNode()),
    _createVNode(AppModal, {
      ref_key: "appModal",
      ref: appModal
    }, null, 512),
    _cache[50] || (_cache[50] = _createTextVNode()),
    _createVNode(ExportAppModal, {
      ref_key: "exportAppModal",
      ref: exportAppModal
    }, null, 512),
    _cache[51] || (_cache[51] = _createTextVNode()),
    _createVNode(AppDeleteModal, {
      ref_key: "appDeleteModal",
      ref: appDeleteModal,
      onDeleted: handleDeleted
    }, null, 512)
  ], 64))
}
}

})